import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const MakingPeaceLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionRebuilding = () => {
    return (
      <>
      <Grid stackable doubling columns="equal" padded='vertically'>
        <Grid.Column stretched>
          <Segment raised className={styles.highlightsItemWhiteBG} >  
            <div style={{width: '100%', height: '100%', display: "inline-block"}}>
              <p className={styles.learnMoreAccordionText} > <br/>
                Often, we will hear someone saying <b>“if only they knew how much I cared about them”</b> or some other form 
                of regret for not making peace with a loved one or family member before it's too late. 
                <br/><br/>
                Building a caregiver relationship can feel like a challenge, especially if the relationship was strained 
                prior to the older adult needing care. Below are a few ways that can help to establish trust and respect 
                in your new role as a caregiver.
              </p>
            <br/>
            </div>
          </Segment>  
        </Grid.Column>
      </Grid>
      </>
    );
  };

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ListenIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > COMMUNICATION IS KEY </p> 
                  <Header.Subheader >
                    <p className={styles.learnMoreAccordionText} >Be willing to communicate often and openly with the older adult. It is usually helpful for both parties 
                        to be upfront about their feelings and needs. It's important not to let feelings of resentment, frustration, 
                        guilt, or anger build up. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Boundaries2.png`} className={`${styles.highlightsItemHeaderImgIcon} ${styles.highlightsIconMedium}`} />
                  <p className={styles.highlightsItemHeaderTitle} > SET BOUNDARIES </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >Rebuilding relationships with a strong foundation requires setting boundaries. This may be especially difficult 
                        if the older adult is a parental figure to the caregiver. Trust and respect from both parties is necessary to 
                        move forward for everyone's best interests. </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'rebuilding',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Rebuilding Relationships </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionRebuilding()}/>)
      }
    },
    { key: 'tips',
      index: 1,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips for Making Peace </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}MakingPeaceLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(MakingPeaceLearnMore);
